import shoppingCartService from "../../services/shoppingCartService";

export default {
    namespaced:true,
    state: {
        cartCount  : 0,
        couponCode : null
    },
    actions:{
        count({state}){
            return shoppingCartService.count().then(res=>{
                if(res.success){
                    state.cartCount = res.response.totalItems;
                }
                return Promise.resolve(res);
            });
        },
        getShoppingCart({state}){
            return shoppingCartService.shoppingCart(state.couponCode).then(res=>{
                return Promise.resolve(res);
            });
        },
        setCouponCode({state},couponCode){
            state.couponCode = couponCode;
        },
        add({state}, stock) {
            if(!stock.quantity) {stock.quantity = 1;}
            return shoppingCartService.add({stockIdx:stock.stockIdx,quantity:stock.quantity}).then(res=>{
                if(res.success){
                    state.cartCount = res.response.totalItems;
                }
                return Promise.resolve(res);
            });
        },
        update({state}, stock) {
            if(!stock.quantity) {stock.quantity = 1;}
            return shoppingCartService.update({stockIdx:stock.stockIdx,quantity:stock.quantity}).then(res=>{
                if(res.success){
                    state.cartCount = res.response.totalItems;
                }
                return Promise.resolve(res);
            });
        },
        remove({state}, shoppingCartIdx) {
            return shoppingCartService.remove(shoppingCartIdx).then(res=>{
                if(res.success){
                    state.cartCount = res.response.totalItems;
                }
                return Promise.resolve(res);
            });
        },
        syncBasketItems({state}){
            shoppingCartService.syncBasketItems().then(res=>{
                if(res.success){
                    state.cartCount = res.response.totalItems;
                }
            });
        },
        setCartCount({state},totalItems){
            state.cartCount = totalItems;
        },



    },
    mutations:{
        /*ET_CART_COUNT({state},totalItems) {
            state.cartCount = totalItems;
        }*/
    },
    getters:{
        basketItems     : (state) => state.basketItems,
        cartCount       : (state) => state.cartCount,
        couponCode      : (state) => state.couponCode,
    }


}